import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';

import Loader from "../../Loader";
import EmptyState from "../../EmptyState";
import FeedLogEntry from "./components/FeedLogEntry";

import useScrollTrigger from "hooks/useScrollTrigger";

import {getFeedLog} from "api/product/feedLog";

FeedLog.propTypes = {
    productId: PropTypes.string
};

function FeedLog({productId}) {
    const intl = useIntl();

    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);

    const [sectionRef, triggered] = useScrollTrigger(productId);

    useEffect(() => {
        if (!triggered || !productId) {
            return;
        }

        setLoading(true);
        getFeedLog(productId)
            .then((res) => {
                setLogs(res);
            })
            .finally(() => setLoading(false));
    }, [triggered, productId]);

    if (!productId) {
        return null;
    }

    return (
        <div ref={sectionRef}>
            {loading && <Loader />}

            {!loading && logs.length === 0 && <EmptyState />}

            {!loading && logs.length > 0 && (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    width: '100%',
                }}>
                    {logs.map((log) => (
                        <FeedLogEntry
                            key={log.id}
                            feedName={log.feedName}
                            date={log.lastEditedByFeed}
                            author={log.launchedBy ? log.launchedBy.firstName : intl.formatMessage({id: 'product.show.feedLog.systemAuthor'})}
                        />
                    ))}
                </div>
            )}
        </div>
    );
}

export default FeedLog;
